// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.barLabel__pbE1d text {
  font-size: 11px !important;
  fill: var(--tables-primary-row-text-main) !important;
}
.barLabel__pbE1d text tspan {
  stroke: unset;
}

.legendLabel__ZYlNy {
  display: flex;
  font-size: 14px;
  column-gap: 8px;
  color: var(--title-inputs-sections-title) !important;
}

.legendTooltip__GddSN {
  background: white !important;
  padding: 8px !important;
  text-align: left !important;
  opacity: 1 !important;
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  color: var(--title-inputs-sections-title) !important;
  background: var(--tables-secondary-row-sub-title-surface) !important;
  border-radius: 4px;
}

.statusName__prrTa {
  font-size: 11px;
  text-transform: uppercase;
  margin-bottom: 8px;
  color: var(--title-inputs-sections-title);
}

.statusBlock__pfPDw {
  display: flex;
  column-gap: 5px;
  margin-top: 5px;
  color: var(--title-inputs-sections-title);
}

.total__lMSQM {
  font-weight: 500;
  color: var(--legend-for-header-text);
}

.percent__KzBTs {
  color: var(--tables-title-text) !important;
}

.labelValue__t5YLh {
  font-size: 20px;
  color: var(--legend-for-header-text);
  font-weight: 500;
}

.labelStatus__UHf3l {
  font-size: 10px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  font-weight: normal;
  white-space: normal;
}

.fullHeightSkeleton__LjY42 {
  min-height: 555px;
}

.skeletonBar__xK0tC {
  height: 60px;
  margin-top: 32px;
}

.skeletonLegend__gZ7El {
  width: 60%;
  height: 20px;
  margin-top: 25px;
}

.skeletonCircle__dBPku {
  width: 350px;
  height: 350px;
  border-radius: 50%;
  margin-top: 55px;
}

.aiStatusTooltip__MV3yZ {
  fill: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
}

.tooltipValue__ZOqKU {
  fill: var(--tables-primary-row-text-main);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ExecutiveSummary/components/ActionItemsStatuses/style.module.scss"],"names":[],"mappings":"AA2EE;EACE,0BAAA;EACA,oDAAA;AA1EJ;AA4EI;EACE,aAAA;AA1EN;;AA+EA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,oDAAA;AA5EF;;AA+EA;EAEE,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,iDAAA;EACA,oDAAA;EACA,oEAAA;EACA,kBAAA;AA7EF;;AAgFA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,yCAAA;AA7EF;;AAgFA;EACE,gBAAA;EACA,oCAAA;AA7EF;;AAgFA;EACE,0CAAA;AA7EF;;AAgFA;EACE,eAAA;EACA,oCAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,eAAA;EACA,yBAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;AA7EF;;AAgFA;EACE,iBAAA;AA7EF;;AAgFA;EACE,YAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,UAAA;EACA,YAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AA7EF;;AAgFA;EACE,gDAAA;EACA,yBAAA;AA7EF;;AAgFA;EACE,yCAAA;AA7EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.barLabel {\n  text {\n    font-size: 11px !important;\n    fill: var(--tables-primary-row-text-main) !important;\n\n    tspan {\n      stroke: unset;\n    }\n  }\n}\n\n.legendLabel {\n  display: flex;\n  font-size: 14px;\n  column-gap: 8px;\n  color: var(--title-inputs-sections-title) !important;\n}\n\n.legendTooltip {\n  // importants below to overwrite react-tooltip styles\n  background: white !important;\n  padding: 8px !important;\n  text-align: left !important;\n  opacity: 1 !important;\n  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);\n  color: var(--title-inputs-sections-title) !important;\n  background: var(--tables-secondary-row-sub-title-surface) !important;\n  border-radius: 4px;\n}\n\n.statusName {\n  font-size: 11px;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  color: var(--title-inputs-sections-title);\n}\n\n.statusBlock {\n  display: flex;\n  column-gap: 5px;\n  margin-top: 5px;\n  color: var(--title-inputs-sections-title);\n}\n\n.total {\n  font-weight: 500;\n  color: var(--legend-for-header-text);\n}\n\n.percent {\n  color: var(--tables-title-text) !important;\n}\n\n.labelValue {\n  font-size: 20px;\n  color: var(--legend-for-header-text);\n  font-weight: 500;\n}\n\n.labelStatus {\n  font-size: 10px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  font-weight: normal;\n  white-space: normal;\n}\n\n.fullHeightSkeleton {\n  min-height: 555px;\n}\n\n.skeletonBar {\n  height: 60px;\n  margin-top: 32px;\n}\n\n.skeletonLegend {\n  width: 60%;\n  height: 20px;\n  margin-top: 25px;\n}\n\n.skeletonCircle {\n  width: 350px;\n  height: 350px;\n  border-radius: 50%;\n  margin-top: 55px;\n}\n\n.aiStatusTooltip {\n  fill: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n}\n\n.tooltipValue {\n  fill: var(--tables-primary-row-text-main);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"barLabel": `barLabel__pbE1d`,
	"legendLabel": `legendLabel__ZYlNy`,
	"legendTooltip": `legendTooltip__GddSN`,
	"statusName": `statusName__prrTa`,
	"statusBlock": `statusBlock__pfPDw`,
	"total": `total__lMSQM`,
	"percent": `percent__KzBTs`,
	"labelValue": `labelValue__t5YLh`,
	"labelStatus": `labelStatus__UHf3l`,
	"fullHeightSkeleton": `fullHeightSkeleton__LjY42`,
	"skeletonBar": `skeletonBar__xK0tC`,
	"skeletonLegend": `skeletonLegend__gZ7El`,
	"skeletonCircle": `skeletonCircle__dBPku`,
	"aiStatusTooltip": `aiStatusTooltip__MV3yZ`,
	"tooltipValue": `tooltipValue__ZOqKU`
};
module.exports = ___CSS_LOADER_EXPORT___;
